<div class="col-12 px-0 d-flex justify-content-center image-div">
  <img class="image" [src]="'assets/images/hazirparam.png'" [srcset]="'assets/images/hazirparam@2x.png 2x, assets/images/hazirparam@3x.png 3x'" alt="logo"/>
</div>
<div class="col-12 px-0 d-flex justify-content-center title-div">
  <label class="title mb-0">Faturana Yansıt Limit Aktarımı</label>
</div>
<div class="col-12 d-flex article-div article-first-div">
  <label class="mb-0 page-article-style">Aktarılacak Tutar</label>
  <label class="mb-0 text-style">{{transferLimit | currency: '₺'}} <img class="edit-icon"
                                                                        [src]="'assets/images/edit.png'"
                                                                        [srcset]="'assets/images/edit@2x.png 2x, assets/images/edit@3x.png 3x'"
                                                                        alt="logo"/></label>
</div>
<div class="col-12 d-flex path-div">
  <div class="path"></div>
</div>
<div class="col-12 d-flex article-div">
  <label class="mb-0 page-article-style">İşlem Ücreti</label>
  <label class="mb-0 text-style">{{processFee | currency: '₺'}}</label>
</div>
<div class="col-12 d-flex path-div">
  <div class="path"></div>
</div>
<div class="col-12 d-flex article-div">
  <label class="mb-0 page-article-style">Toplam Tutar</label>
  <label class="mb-0 text-style">{{totalPrice | currency: '₺'}}</label>
</div>

<div class="col-12 d-flex info-div">
  <img class="info" [src]="'assets/images/info.png'" [srcset]="'assets/images/info@2x.png 2x, assets/images/info@3x.png 3x'" alt="logo"/>
  <label class="info-description">Sanal Paranız bozdurularak bakiyenize aktarılacaktır.</label>
</div>

<div class="col-12 d-flex button-group">
  <div class="w-100">
    <button class="cancel-button"><span class="text-style">İptal Et</span></button>
  </div>
  <div class="w-100 ml-2">
    <button class="approval-button"><span class="text-style">Onaylıyorum</span></button>
  </div>
</div>
